import { useContext } from "react";
import { TableMonitorContext } from "../contexts/TableMonitorContext";

export function useTableMonitor() {
    const context = useContext(TableMonitorContext);
    return context;
}
